import { createReducer, createAction } from 'redux-act'
import { selector as configSelector } from '~/config'
import { select, apply, put, takeEvery, all } from 'redux-saga/effects'
import { get } from 'lodash'

import { Entity, handleError } from '~/utils/entity-utils'

import API from '~/api'

const entityName = 'downloadAccess';
const entity = new Entity(entityName, API, configSelector, {
  key: 'url',
  route: 'download-accesses'
});

// ACTIONS
export const actions = {
  ...entity.actions,
  downloadAction: {
    request: createAction('download action request', (actionUrl) => ({actionUrl})),
    failure: createAction('download action failure', (message) => ({message})),
    success: createAction('download action success', (download) => ({download}))
  },
};

// WORKERS
export const workers = {
  ...entity.workers,
  * applyDownloadAction(action) {
    const { actionUrl, params } = get(action, 'payload', {});

    try {
      const config = yield select(configSelector);
      const api = new API(config);
      const response = yield apply(api, api.call, [actionUrl, 'POST']);

      yield put(actions.downloadAction.success(response.data));
    } catch (e) {
      handleError(e, actions.downloadAction);
      throw e;
    }
  },
};

// SAGA
export function * saga() {
  yield all([
    ...entity.saga,
    takeEvery(actions.downloadAction.request().type, workers.applyDownloadAction)
  ]);
}

export const reducer = createReducer(entity.reducer, {});

export default {
  actions,
  workers,
  saga,
  reducer
}